<!--
  - Copyright (c) 2021 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-container
    fluid
    class="fill-height px-0"
  >
    <v-card width="100%" height="100%" :loading="active" :elevation="active ? 12 : 4">
      <template v-slot:progress><v-progress-linear color="warning" :value="progress" v-if="active"/></template>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-subtitle class="text-left">
        <slot name="subtitle">{{ subtitle }}</slot>
      </v-card-subtitle>
      <v-card-text>
        <slot v-if="showContent"></slot>
        <slot v-else name="placeholder"></slot>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "OneStepItem",
  data() {
    return {
      active: false,
      showContent: false
    }
  },
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    focus: {
      type: Function,
    },
    blur: {
      type: Function
    },
  },
  computed: {
    progress() {
      return this.$parent.$parent.progress
    },
    timelineItemAttrs() {
      let obj = {}
/*
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          Object.assign(obj, {fillDot: true, small: true})
      }
      if (this.active)
        Object.assign(obj, {color: 'primary'})
      else
        Object.assign(obj, {color: 'primary lighten-3', small: true})
*/

      return obj
    }
  },
}
</script>

<style scoped>
</style>
